<template>
	<div class="myupload">
		<el-upload v-if="uptype == 1 || uptype == 3" ref="upload" class="avatar-uploader" action="#"
			:show-file-list="false" :on-change="beforeAvatarUpload" accept="image/*" :data="updata"
			:headers="uploadheader" :auto-upload="false" :http-request="handleUpload" :disabled="disabled">
			<img v-if="imageUrl && uptype == 1" :src="imageUrl" class="avatar" @click="ondisabled">
			<i v-else class="el-icon-plus avatar-uploader-icon" @click="ondisabled"></i>
		</el-upload>

		<el-upload v-if="uptype == 2" ref="upload" action="#" :show-file-list="false" :http-request="handleUpload"
			:on-change="beforeAvatarUpload" accept=".pdf, .doc, .docx, .xls, .xlsx" :data="updata"
			:headers="uploadheader" :auto-upload="false">
			<el-button size="small" type="primary">点击上传</el-button>
		</el-upload>
	</div>
</template>

<script>
	export default {
		name: 'myupload',
		data() {
			return {
				updata: {
					file_name: "",
					file_ext: "",
					file_content: ""
				},
				imageUrl: "",
				totalChunks: 0,
				uploadedChunks: 0,
				chunkSize: 1 * 1024 * 512
			}
		},

		inject: ['uploadurl', 'uploadheader'],

		props: {
			uptype: {
				type: Number,
				default: 1
			},

			imgurl: {
				type: String,
				default: ""
			},
			
			disabled: {
				type: Boolean,
				default: false
			}
		},

		watch: {
			imgurl: {
				handler(newVal, oldVal) {
					this.imageUrl = newVal;
				},
				immediate: true // 初始化时立即执行
			}
		},

		methods: {
			handleAvatarSuccess(res, file) {
				if (res.code == 0) {
					this.imageUrl = res.data.src;
					this.$message.success('上传成功');
					this.$emit('resultUrl', this.imageUrl, res.data, file);
				}
			},

			handleAvatarError() {
				this.$message.error('上传失败');
			},

			beforeAvatarUpload(file) {
				var that = this;
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传大小不能超过 2MB!');
					return false;
				}

				this.handleUpload(file);
			},

			async handleUpload(file) {
				var a = Math.floor(1000 + Math.random() * 9000).toString();
				var name = a + JSON.parse(JSON.stringify(new Date().getTime()));
				this.totalChunks = Math.ceil(file.size / this.chunkSize);
				this.uploadedChunks = 0;
				var that = this;
				for (let i = 0; i < this.totalChunks; i++) {
					const start = i * this.chunkSize;
					const end = Math.min(file.size, start + this.chunkSize);
					const chunk = file.raw.slice(start, end);
					await this.onupload(chunk, i, file, name)
				};
			},

			async onupload(chunk, i, file, name) {
				var that = this;
				const reader = new FileReader();
				reader.readAsDataURL(chunk);
				return new Promise((resolve, reject) => {
					reader.onload = async function(e) {
						const base64 = e.target.result;
						const formData = new FormData();
						formData.append("file_name", name);
						formData.append("file_ext", file.name.slice(file.name.lastIndexOf('.') +
							1));
						formData.append("file_content", base64.split(',')[1]);
						await that.$axios.post("/api/user/upload", formData).then(res => {
							console.log('排序' + i);
							if (res.data.code == 0) {
								that.uploadedChunks++;
								resolve();
								if (that.uploadedChunks == that.totalChunks) {
									that.imageUrl = res.data.data.src;
									that.$message.success('上传成功');
									that.$emit('resultUrl', that.imageUrl, res.data.data, file);
									that.totalChunks = 0;
									that.uploadedChunks = 0;
									reject();
								}
							} else {
								that.$message.error('上传失败');
								that.totalChunks = 0;
								that.uploadedChunks = 0;
								that.imageUrl = "";
								reject();
							}
						});
					}
				})
			},
			
			ondisabled() {
				if(this.disabled) {
					this.$message.warning('以达到上传条数');
				}
			}
		}
	}
</script>

<style scoped lang="less">
	/deep/ .avatar-uploader .el-upload {
		border: 1px dashed #ff4714;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	/deep/ .avatar-uploader .el-upload:hover {
		border-color: #ff4714;
	}

	/deep/ .avatar-uploader-icon {
		font-size: 28px;
		color: #ff4714;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	/deep/ .avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>



// WEBPACK FOOTER //
// src/common/myupload.vue